<template>
  <div>
    <template
      v-for="(varItem, index) in getActorVars(actor)"
    >
      <hr
        v-if="index > 0"
        :key="`h-${varItem.id}`"
      />
      <b-row align-h="center" :key="`s-${varItem.id}`">
        <b-col cols="6" class="text-left">
          <span class="mr-3">{{ displayName(varItem) }}</span>
        </b-col>
        <b-col cols="6" class="text-right">
          <span :data-vid="varItem.id">
            <font-awesome-icon v-if="varItem.icon" :icon="varItem.icon" class="mr-1" />
            <template v-if="varItem.component">
              <component
                v-bind:is="varItem.component"
                :vars="[varItem]"
              />
            </template>
            <template v-else>
              <template v-if="typeof varItem.value  === 'boolean'">
                <font-awesome-icon
                  icon="circle"
                  :class="[varItem.value
                    ? 'text-success'
                    : 'text-black-25'
                  ]"
                />
              </template>
              <template v-else>
                {{ varItem.value }} {{ varItem.unit ? varItem.unit : '' }}
              </template>
            </template>
          </span>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'StructDisplayList',
  props: {
    actor: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('snapshot', [
      'currentSnapshot',
    ]),
    ...mapGetters([
      'getActorVars',
    ]),
  },
  methods: {
    displayName(varItem) {
      if (this.currentSnapshot.rev === 2) {
        return varItem.title;
      }
      return varItem.description;
    },
  },
};
</script>

<style scoped>

</style>
